import { UPEditActionIcon } from './styles';

export default UPEditActionIcon;
